export default __webpack_public_path__ + "static/media/hoppia_vtuber_02.dc7e3f78.png";